import React from 'react';

// Components
import Table from 'Console/components/common/Table/Table';

const SegmentsTable = ({ onRowClick, segments }) => (
    <>
        <div style={{ position: 'relative' }}>
            <Table
                options={{
                    pagination: {
                        rowsPerPage: 4,
                        rowsPerPageOptions: [2, 3, 4, 20],
                    },
                    actions: {
                        rowClick: onRowClick,
                    },
                    dataToIgnore: ['id', 'systemKey'],
                }}
                columns={[
                    {
                        label: 'Name',
                        fieldName: 'name',
                    },
                    {
                        label: 'Kind',
                        fieldName: 'kind',
                    },

                    {
                        label: 'Value type',
                        fieldName: 'valueType',
                    },
                    {
                        label: 'Description',
                        fieldName: 'description',
                    },
                    {
                        label: 'Active',
                        fieldName: 'active',
                    },
                ]}
                data={segments}
            />
        </div>
    </>
);

export default SegmentsTable;
